import React, { useState, useEffect } from "react";
import { Table, Button, Space, Input, Tooltip, message, Modal } from "antd";
// import { Modal, Form, Input, Select, Checkbox, Button, Table, Space, Tooltip, message } from 'antd';

import {
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import UserPopupCompo from "../../component/dashboard/UserPopupCompo";
import HeaderCompo from "../../component/Header";
import { axiosInstance } from "../../utils/axiosInterceptor";
import Chat from "../../components/chats/Chat";
import { useSelector } from "react-redux";

const Users = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userRoleSource, setUserRoleSource] = useState(null);
  const [chatBoxOpen, setChatOpen] = useState(false)
  const [searchText, setSearchText] = useState("");
  const token = localStorage.getItem("token");
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${BE_HOST}/users/all`);
      setDataSource(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };


  const fetchRole = async () => {
    // setLoading(true);
    try {
      const response = await axiosInstance.get(`/users/roles`, 
      //   {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      // }
    );
      // console.log("response Role-->", response);
      setUserRoleSource(response?.data?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    // setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
    fetchRole();
  }, []);

  const filteredData = dataSource?.filter(
    (user) =>
      user.email?.toLowerCase().includes(searchText.toLowerCase()) ||
      `${user.first_name} ${user.last_name}`
        .toLowerCase()
        .includes(searchText.toLowerCase())
  );

  const handleEdit = (user) => {
    setSelectedUser(user);
    setPopupVisible(true);
  };

  const handleDelete = async (userId) => {
    Modal.confirm({
      title: "Delete User",
      content: "Are you sure you want to delete this user?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      okButtonProps: {
        style: {
          float: "left",
        },
      },
      cancelButtonProps: {
        style: {
          float: "right",
        },
      },
      onOk: async () => {
        try {
          const token = localStorage.getItem("token");
          await axiosInstance.delete(`/users/delete?email=${userId}`, {
            // headers: {
            //   "Content-Type": "application/json",
            //   Authorization: `Bearer ${token}`,
            // },
          });
          message.success("User deleted successfully");
          fetchUsers();
        } catch (error) {
          message.error(
            error.response?.data?.message || "Failed to delete user"
          );
          console.error("Error deleting user:", error);
        }
      },
    });
  };

  // Update the delete button onClick to pass email instead of id
  const columns = [
    {
      title: "Email/Username",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      sorter: (a, b) => a.first_name?.localeCompare(b.first_name),
    },
    {
      title: "Middle Name",
      dataIndex: "middle_name",
      key: "middle_name",
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      sorter: (a, b) => a.last_name?.localeCompare(b.last_name),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const statusMap = {
          0: "Not Registered",
          1: "Registered/Active",
          3: "Disabled",
        };
        return statusMap[status] || status;
      },
      filters: [
        { text: "Not Registered", value: 0 },
        { text: "Registered/Active", value: 1 },
        { text: "Disabled", value: 3 },
      ],
      onFilter: (value, record) => record.status === value,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit User">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Tooltip title="Delete User">
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record.email)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleAddNew = () => {
    setSelectedUser(null);
    setPopupVisible(true);
  };

  return (
    <>

    {/* // <Layout className="layout tbl-bg-layout"> */}
     <HeaderCompo initialColor={'#000833'} /> 

    <div className="p-4">
      <UserPopupCompo
        popupWithScrollViewVisible={popupVisible}
        hide={() => setPopupVisible(false)}
        data={selectedUser}
        userRoleSource={userRoleSource}
        isNewRecord={!selectedUser}
        fetchUsers={fetchUsers}
      />
      <div
        className="flex md:items-center md:justify-between  flex-col md:flex-row gap-4 mb-4 px-4 pt-4"
        style={{ padding: "16px 16px 0px 16px" }}
      >
        <h1 className="text-2xl font-bold">Users Management</h1>
        {/* <Space> */}
          <div className="flex sm:flex-row gap-2 w-full md:w-auto">

          <Input
            placeholder="Search by email or name"
            prefix={<SearchOutlined />}
            onChange={(e) => setSearchText(e.target.value)}
            className="w-[90%] sm:w-[250px] "
            style={{ border: "1px solid var(--Primary-Dark-Blue, #000833)" , height:"40px" }}
            allowClear
          />
          <Tooltip title="Add New User">
            <Button
              type="primary"
              icon={<UserAddOutlined />}
              onClick={handleAddNew}
              style={{height:"40px" }}
            />
          </Tooltip>
        </div>
      </div>

      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
        loading={loading}
        scroll={{ x: "max-content" }} 
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} users`,
        }}
        className="custom-table user-tbl"
      />
      {/* {userAuth?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
                <div className="chat-button" onClick={() => setChatOpen(true)}>
                  💬 Let’s Chat
                </div>
              )}
              <Chat
                      open={chatBoxOpen}
                      setOpen={setChatOpen}
                    /> */}
    </div>
    </>
    // </Layout>
  );
};

export default Users;
